<template>
  <div id="app">
    <Navigation :user="user" @logout="logout" />
    <router-view
      class="container"
      :user="user"
      :dbInfo="dbInfo"
      :rejectMessage="rejectMessage"
      :infoMessage="infoMessage"
      :saveStatus="saveStatus"
      :projects="projects"
      :microbes="microbes"
      :strains="strains"
      :libraries="libraries"
      :selectedProject="selectedProject"
      :selectedCart="selectedCart"
      :selectedPackage="selectedPackage"
      :error="error"
      @logout="logout"
      @addItem="addItem"
      @saveItem="saveItem"
      @selectCart="selectCart"
      @selectPackage="selectPackage"
      @setInfoMessage="setInfoMessage"
      @setSaveStatus="setSaveStatus"
    />
    <OlabFooter :user="user" />
  </div>
</template>

<script>
// @ is an alias to /src
import Navigation from "@/components/Navigation.vue";
import OlabFooter from "@/components/OlabFooter.vue";
import firebase from "firebase";
import db from "./olab/db.js";
import axios from "axios";
import { OlabUser } from "./olab/olabuser.js";
import { OlabItem } from "./olab/olabitem.js";
import { OlabGene } from "./olab/olabgene.js";
import { OlabCart } from "./olab/olabcart.js";
import { OlabPackage } from "./olab/olabpackage.js";
import { OlabProject } from "./olab/olabproject.js";
import { OlabStrain } from "./olab/olabstrain.js";
import { OlabSequence } from "./olab/olabsequence.js";
import { OlabUtils } from "./olab/olabutils.js";
// import { OlabDesign } from "./olab/olabdesign.js";
// import { OlabSearch } from "./olab/olabsearch.js";
// import { OlabDataFile } from "./olab/olabdatafile.js";
// import { OlabBlock } from "./olab/olabblock.js";

export default {
  name: "app",
  data: function() {
    return {
      // For batch load of RBS data
      // rbsData: [],
      blockData: [],
      genes: [],
      // geneUpdateData: [],
      // blockConfig: null,
      // blockConfigs: null,
      dbInfo: null,
      user: null,
      rejectMessage: null,
      infoMessage: null,
      saveStatus: false,
      projects: [],
      microbes: [],
      strains: [],
      libraries: [],
      selectedProject: null,
      selectedCart: null,
      selectedPackage: null,
      error: null
    };
  },
  components: {
    Navigation,
    OlabFooter
  },
  mounted() {
    let info = {};
    db.collection("db")
      .doc("info")
      .get()
      .then(snapshot => {
        info.name = snapshot.data().name;
        info.owner = snapshot.data().owner;
        info.db_configs = snapshot.data().db_configs;
        this.dbInfo = info;
      });

    firebase.auth().onAuthStateChanged(authUser => {
      if (authUser) {
        this.user = authUser;
        // Read user from the test/olab_users collection
        // cjcj users will use cjcj/olab_users collection
        // and olab users will use olab/olab_users collection
        // OlabUtils.infoLog("App: users/test/olab_users");
        db.collection("users/cjcj/olab_users")
          .withConverter(OlabUser.getUpdateOlabUserConverter())
          .doc(authUser.email)
          .get()
          .then(snapshot => {
            this.user = snapshot.data();
            // Note: Add authUser to user for debugging purposes
            this.user.authUser = authUser;
            // OlabUtils.infoLog("App: Sign-in provider: " + authUser.providerId);
            // OlabUser.infoLog(this.user);
            this.rejectMessage = null;
            if (this.user.status == "pending") {
              this.rejectMessage =
                "Please check back later, your account is still being process ...";
              setTimeout(() => {
                this.logout();
              }, 100);
            } else if (this.user.status != "active") {
              this.rejectMessage =
                "Please check with your admin, your account has an error";
              setTimeout(() => {
                this.logout();
              }, 100);
            } else if (this.user.status == "active") {
              // Load cart and project if selected is not null
              if (this.user.selected) {
                if (this.user.selected.cart_id) {
                  const cartRef =
                    "projects/PJ/olab_items/" +
                    this.user.selected.project_id +
                    "/olab_carts";
                  db.collection(cartRef)
                    .doc(this.user.selected.cart_id)
                    .withConverter(OlabCart.getOlabCartConverter())
                    .get()
                    .then(
                      function(doc) {
                        if (doc.exists) {
                          // Convert to Cart object
                          this.selectedCart = doc.data();
                        } else {
                          OlabUtils.infoLog("No such document!");
                        }
                      }.bind(this)
                    )
                    .catch(function(error) {
                      OlabUtils.infoLog("Error getting document:" + error);
                    });
                }
                if (this.user.selected.project_id) {
                  db.collection("projects/PJ/olab_items")
                    .doc(this.user.selected.project_id)
                    .withConverter(OlabItem.getOlabItemConverter())
                    .get()
                    .then(
                      function(doc) {
                        if (doc.exists) {
                          // Convert to Project object
                          this.selectedProject = doc.data();
                        } else {
                          OlabUtils.infoLog("No such document!");
                        }
                      }.bind(this)
                    )
                    .catch(function(error) {
                      OlabUtils.infoLog("Error getting document:" + error);
                    });
                }
                if (this.user.selected.package_id) {
                  db.collection("packages/PG/olab_items")
                    .doc(this.user.selected.package_id)
                    .withConverter(OlabItem.getOlabItemConverter())
                    .get()
                    .then(
                      function(doc) {
                        if (doc.exists) {
                          // Convert to Package object
                          this.selectedPackage = doc.data();
                        } else {
                          OlabUtils.infoLog("No such document!");
                        }
                      }.bind(this)
                    )
                    .catch(function(error) {
                      OlabUtils.infoLog("Error getting document:" + error);
                    });
                }
              }
            }
          })
          .catch(
            function(error) {
              // Handle Errors here.
              this.error = error.code + ": " + error.message;
              OlabUtils.infoLog("authUser.email not found = " + authUser.email);
              this.rejectMessage = "Sorry, this service is for members only";
              setTimeout(() => {
                this.logout();
              }, 100);
            }.bind(this)
          );

        let olabItemConverter = OlabItem.getOlabItemConverter();

        db.collection("microbes")
          .withConverter(olabItemConverter)
          .limit(15)
          .get()
          .then(snapshot => {
            const snapArr = [];
            snapshot.forEach(doc => {
              if (doc.id == "stats") {
                this.stats.microbesCount = doc.data().count;
              } else {
                // OlabUtils.infoLog(doc.id + " => " + doc.data());
                snapArr.push(doc.data());
              }
            });
            this.microbes = snapArr;
            OlabUtils.infoLog("microbes len = " + this.microbes.length);
          });

        db.collection("libraries")
          .withConverter(olabItemConverter)
          .limit(15)
          .get()
          .then(snapshot => {
            const snapArr = [];
            snapshot.forEach(doc => {
              if (doc.id == "stats") {
                this.stats.librariesCount = doc.data().count;
              } else {
                // OlabUtils.infoLog(doc.id + " => " + doc.data());
                snapArr.push(doc.data());
              }
            });
            this.libraries = snapArr;
            OlabUtils.infoLog("libraries len = " + this.libraries.length);
          });

        db.collection("projects/PJ/olab_items")
          .withConverter(olabItemConverter)
          .limit(15)
          .onSnapshot(snapshot => {
            const snapArr = [];
            snapshot.forEach(doc => {
              // OlabUtils.infoLog(doc.id + " => " + doc.data());
              snapArr.push(doc.data());
            });
            this.projects = snapArr;
            OlabUtils.infoLog("projects len = " + this.projects.length);
          });

        db.collectionGroup("olab_items")
          .where("olab_type", "==", "strain")
          .where("olab_id", ">=", "")
          .limit(15)
          .withConverter(olabItemConverter)
          .get()
          .then(snapshot => {
            const snapArr = [];
            snapshot.forEach(function(doc) {
              // OlabUtils.infoLog(doc.id + " => " + doc.data());
              snapArr.push(doc.data());
            });
            this.strains = snapArr;
            OlabUtils.infoLog("strains len = " + this.strains.length);
          });

        // // Needed for loading gene data to FB
        // // Load block configuration information
        // db.collection("db")
        //   .doc("info")
        //   .get()
        //   .then(snapshot => {
        //     this.blockConfigs = snapshot.data().db_configs.block_configs;
        //     this.blockConfig = OlabBlock.getConfigBlock("ECO-S00001-C01-0000", this.blockConfigs);
        //     if (this.blockConfig) {
        //       // Load Gene Update data for test run
        //       // OlabDataFile.uploadGeneData("CGL", "CGL-S00001", "CGL-S00001-C01",
        //       //  "./cj-genes.json", this.geneUpdateData, this.blockConfig);
        //       // Next start at 251 (yagL)
        //       // OlabDataFile.uploadGeneData("ECO", "ECO-CJ0001", "ECO-CJ0001-C01", 101,
        //       //   "./cj-genes.json", this.geneUpdateData, this.blockConfig);
        //     }
        //   });

        // Reset gene fields
        // OlabDataFile.resetGeneData("ECO", "ECO-S00001", "ECO-S00001-C01", 501, 601);
        // Update Data to append *_uc fields
        // OlabSearch.searchAndUpdateSequencesUC("LG", "olab_id", 300);
        // OlabSearch.searchAndUpdatePackagesUC("PG", "olab_id", 30);
        // OlabSearch.searchAndUpdateCartsUC("CT", "olab_id", 30);
        // OlabSearch.searchAndUpdateProjectsUC("PJ", "olab_id", 20);
        // OlabSearch.searchAndUpdateGenesUC("ECO", "ECO-S00001", "ECO", "olab_id", 10000);

        // Load CJ RBS data for test run
        // OlabDataFile.loadRBSData("./rbs_seqs.json", this.rbsData);

        // // Load the genes to Firebase
        // this.loadGeneFiles(
        //   "CGL",
        //   "CGL-S00002",
        //   "./data/CGL13869/genes/coryatcc13869_",
        //   100,
        //   151
        // );
        // this.loadGeneFiles(
        //   "CST",
        //   "CST-S00001",
        //   "./data/CST6872/genes/coryatcc6872_",
        //   2,
        //   130
        // );
        // this.loadGeneFiles("CGL", "CGL-S00001", "./data/CGL/genes/coryatcc13032_", 1, 152);
        // this.loadGeneFiles("ECO", "ECO-S00001", "./data/ECOLI/genes/ecoli_", 1, 50);
        // this.loadGeneFiles("ECO", "ECO-S00001", "./data/ECOLI-2020/geneswithbnum/ecoli2020_", 100, 219);
        // this.loadGeneFiles("CGL", "CGL-CJ0001", "./cj-data/CGL-v2/genes/cgl_", 1, 161);
        // this.loadGeneFiles("CGL", "CGL-CJ0001", "./cj-data/CGL-v2/geneswithSynonym/cglsyn_", 2, 161);
        // this.loadGeneFiles("ECO", "ECO-CJ0001", "./cj-data/ECOLI-v2/genes/ecoli_", 1, 234);
        // this.loadGeneFiles("ECO", "ECO-CJ0001", "./cj-data/ECOLI-v2/geneswithSynonym/ecosyn_", 2, 234);

        // Load the gene's block files to Firebase
        // OlabDataFile.loadGeneBlockFiles(
        //   "data/CST6872/blocks/coryatcc6872-",
        //   "CST",
        //   "S00001",
        //   "C01",
        //   0,
        //   952,
        //   this.blockData
        // );
        // OlabDataFile.loadGeneBlockFiles(
        //   "data/CGL13869/blocks/coryatcc13869-",
        //   "CGL",
        //   "S00002",
        //   "C01",
        //   0,
        //   1099,
        //   this.blockData
        // );
      }
    });
  },
  methods: {
    loadSingleGeneFile: function(microbeID, strainID, name) {
      return new Promise(resolve => {
        OlabUtils.infoLog("Load file = " + name + ".json");
        // 6 seconds
        setTimeout(resolve, 6000);
        // Load the genes to Firebase
        axios.get(name + ".json").then(response => {
          const geneArr = response.data;
          const olabGenes = [];
          for (let i = 0; i < geneArr.length; i++) {
            OlabUtils.infoLog("gene " + i + ": " + geneArr[i].olab_id);
            // Set additional fields and append unique key for search to work later
            if (geneArr[i].name != null && geneArr[i].name != "") {
              geneArr[i].name_uc =
                geneArr[i].name.toUpperCase() + " ^%#- " + geneArr[i].olab_id;
            }
            if (
              geneArr[i].synonym_name1 != null &&
              geneArr[i].synonym_name1 != ""
            ) {
              geneArr[i].synonym_name1_uc =
                geneArr[i].synonym_name1.toUpperCase() +
                " ^%#- " +
                geneArr[i].olab_id;
            }
            if (
              geneArr[i].synonym_name2 != null &&
              geneArr[i].synonym_name2 != ""
            ) {
              geneArr[i].synonym_name2_uc =
                geneArr[i].synonym_name2.toUpperCase() +
                " ^%#- " +
                geneArr[i].olab_id;
            }
            if (
              geneArr[i].synonym_name3 != null &&
              geneArr[i].synonym_name3 != ""
            ) {
              geneArr[i].synonym_name3_uc =
                geneArr[i].synonym_name3.toUpperCase() +
                " ^%#- " +
                geneArr[i].olab_id;
            }
            if (
              geneArr[i].synonym_name4 != null &&
              geneArr[i].synonym_name4 != ""
            ) {
              geneArr[i].synonym_name4_uc =
                geneArr[i].synonym_name4.toUpperCase() +
                " ^%#- " +
                geneArr[i].olab_id;
            }
            if (
              geneArr[i].synonym_name5 != null &&
              geneArr[i].synonym_name5 != ""
            ) {
              geneArr[i].synonym_name5_uc =
                geneArr[i].synonym_name5.toUpperCase() +
                " ^%#- " +
                geneArr[i].olab_id;
            }
            if (geneArr[i].b_number != null) {
              geneArr[i].b_number_uc = geneArr[i].b_number.toUpperCase();
            }
            if (geneArr[i].old_locus_tag != null) {
              geneArr[i].old_locus_tag_uc = geneArr[
                i
              ].old_locus_tag.toUpperCase();
            }
            olabGenes.push(new OlabGene(geneArr[i]));
          }
          this.genes = olabGenes;
          this.uploadGenesToFB(microbeID, strainID);
        });
      });
    },
    loadGeneFiles: async function(microbeID, strainID, name, from, to) {
      for (let i = from; i < to; i++) {
        OlabUtils.infoLog("Load file = " + name);
        await this.loadSingleGeneFile(microbeID, strainID, name + i);
      }
    },
    uploadGeneWithTimer: function(microbeID, strainID, ms, index) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
        OlabUtils.infoLog(
          "XXX Milliseconds = " +
            ms +
            ", Index = " +
            index +
            ", olab_id = " +
            this.genes[index].olab_id
        );
        const collectionStr =
          "microbes/" + microbeID + "/olab_items/" + strainID + "/olab_genes";
        OlabUtils.infoLog("collectionStr = " + collectionStr);
        db.collection(collectionStr)
          .withConverter(OlabGene.getOlabGeneConverter())
          .doc(this.genes[index].olab_id)
          .set(this.genes[index], { merge: true })
          .then(function() {
            OlabUtils.infoLog(
              "Document successfully written! Index = " + index
            );
          })
          .catch(function(error) {
            OlabUtils.infoLog("Error writing document: " + error);
          });
      });
    },
    uploadGenesToFB: async function(microbeID, strainID) {
      for (let i = 0; i < this.genes.length; i++) {
        let ms = i * 10;
        console.log(ms + " milliseconds");
        await this.uploadGeneWithTimer(microbeID, strainID, ms, i);
      }
    },
    addItem: function({ item, type, items }) {
      OlabUtils.infoLog(
        "addItem: item.olab_id = " +
          item.olab_id +
          ", type = " +
          type +
          ", items = " +
          items
      );

      // Set additional fields
      item.olab_type = type;

      // Set library_id if this item is a package item
      if (item.package_type) {
        item.library_id = OlabPackage.pkgTypeToLibraryID(item.package_type);
      }

      switch (type) {
        case "project":
          // Increment count atomically
          db.collection("projects")
            .doc("PJ")
            .update({
              count: firebase.firestore.FieldValue.increment(1)
            })
            .then(
              function() {
                // Read count value back
                db.collection("projects")
                  .doc("PJ")
                  .get()
                  .then(snapshot => {
                    const tmp_count = snapshot.data().count;
                    OlabUtils.infoLog("project: tmp_count = " + tmp_count);
                    const tmp_countHex = tmp_count.toString(16).toUpperCase();
                    OlabUtils.infoLog(
                      "project: tmp_countHex = " + tmp_countHex
                    );

                    item.olab_id =
                      "PJ-" + tmp_countHex.toString().padStart(5, "0");
                    OlabUtils.infoLog(
                      "project: item.olab_id = " + item.olab_id
                    );
                    // Set additional fields and append unique key for search to work later
                    item.setUniqueKey();

                    // Add new project to projects
                    db.collection("projects/PJ/olab_items")
                      .withConverter(OlabProject.getCreateItemConverter())
                      .doc(item.olab_id)
                      .set(item)
                      .then(
                        function() {
                          // console.log("Document successfully written!");
                          // copy item to a new object and add that to the computed list
                          items.push(Object.assign(new OlabItem(), item));
                        }.bind(this)
                      )
                      .catch(
                        function(error) {
                          // console.error("Error writing document: " + error);
                          this.error = error;
                        }.bind(this)
                      );
                  });
              }.bind(this)
            )
            .catch(
              function(error) {
                // console.error("Error writing document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
        case "cart":
          var projID = item.project_id.substr(0, item.project_id.indexOf(" "));
          // Remove project desc from project id field for storing
          item.project_id = projID;

          // Increment count atomically
          db.collection("projects/PJ/olab_items")
            .doc(projID)
            .update({
              cart_count: firebase.firestore.FieldValue.increment(1)
            })
            .then(
              function() {
                // Read count value back
                db.collection("projects/PJ/olab_items")
                  .doc(projID)
                  .get()
                  .then(snapshot => {
                    const tmp_count = snapshot.data().cart_count;
                    OlabUtils.infoLog("cart count: tmp_count = " + tmp_count);
                    const tmp_countHex = tmp_count.toString(16).toUpperCase();
                    OlabUtils.infoLog(
                      "cart count: tmp_countHex = " + tmp_countHex
                    );

                    item.olab_id =
                      "CT-" +
                      projID +
                      "-" +
                      tmp_countHex.toString().padStart(3, "0");
                    OlabUtils.infoLog("cart: item.olab_id = " + item.olab_id);
                    // Set additional fields and append unique key for search to work later
                    item.setUniqueKey();

                    // Add new cart to project
                    const cartsRef =
                      "projects/PJ/olab_items/" + projID + "/olab_carts";
                    OlabUtils.infoLog("project's carts ref = " + cartsRef);
                    db.collection(cartsRef)
                      .withConverter(OlabCart.getCreateCartConverter())
                      .doc(item.olab_id)
                      .set(item)
                      .then(
                        function() {
                          // OlabUtils.infoLog("Document successfully written!");
                          // copy item to a new object and add that to carts
                          items.push(Object.assign(new OlabCart(), item));
                        }.bind(this)
                      )
                      .catch(
                        function(error) {
                          OlabUtils.infoLog("Error writing document: " + error);
                          this.error = error;
                        }.bind(this)
                      );
                  });
              }.bind(this)
            )
            .catch(
              function(error) {
                OlabUtils.infoLog("Error reading document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
        case "package":
          // Increment count atomically
          db.collection("packages")
            .doc("PG")
            .update({
              count: firebase.firestore.FieldValue.increment(1)
            })
            .then(
              function() {
                // Read count value back
                db.collection("packages")
                  .doc("PG")
                  .get()
                  .then(snapshot => {
                    const tmp_count = snapshot.data().count;
                    OlabUtils.infoLog("package: tmp_count = " + tmp_count);
                    const tmp_countHex = tmp_count.toString(16).toUpperCase();
                    OlabUtils.infoLog(
                      "package: tmp_countHex = " + tmp_countHex
                    );

                    item.olab_id =
                      "PG-" + tmp_countHex.toString().padStart(5, "0");
                    OlabUtils.infoLog(
                      "package: item.olab_id = " + item.olab_id
                    );
                    // Set additional fields and append unique key for search to work later
                    item.setUniqueKey();

                    // Add new package to projects
                    db.collection("packages/PG/olab_items")
                      .withConverter(OlabPackage.getCreatePackageConverter())
                      .doc(item.olab_id)
                      .set(item)
                      .then(
                        function() {
                          // console.log("Document successfully written!");
                          // copy item to a new object and add that to the computed list
                          items.push(Object.assign(new OlabPackage(), item));
                        }.bind(this)
                      )
                      .catch(
                        function(error) {
                          // console.error("Error writing document: " + error);
                          this.error = error;
                        }.bind(this)
                      );
                  });
              }.bind(this)
            )
            .catch(
              function(error) {
                // console.error("Error writing document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
        case "strain":
          var microbesDB = db.collection("microbes");
          OlabUtils.infoLog("item.parent_id = " + item.parent_id);
          var parentID = item.parent_id.substr(0, item.parent_id.indexOf(" "));
          OlabUtils.infoLog("parentID = " + parentID);
          var microbeID = parentID.substr(0, parentID.indexOf("-"));
          OlabUtils.infoLog("microbeID = " + microbeID);
          var parentCount = 0;

          // Validate item's parent id
          microbesDB
            .where("olab_id", "==", microbeID)
            .get()
            .then(
              function(querySnapshot) {
                querySnapshot.forEach(
                  function(doc) {
                    OlabUtils.infoLog(doc.id + " => " + doc.data().olab_id);
                    parentCount++;
                  }.bind(this)
                );
                OlabUtils.infoLog("querySnapshot found count = " + parentCount);

                // Increment microbeID's strains_count atomically
                microbesDB
                  .doc(microbeID)
                  .update({
                    count: firebase.firestore.FieldValue.increment(1)
                  })
                  .then(
                    function() {
                      // Read count value back
                      microbesDB
                        .doc(microbeID)
                        .get()
                        .then(snapshot => {
                          const tmp_count = snapshot.data().count;
                          OlabUtils.infoLog("strain: tmp_count = " + tmp_count);
                          const tmp_countHex = tmp_count
                            .toString(16)
                            .toUpperCase();
                          OlabUtils.infoLog(
                            "strain: tmp_countHex = " + tmp_countHex
                          );

                          item.olab_id =
                            microbeID +
                            "-S" +
                            tmp_countHex.toString().padStart(5, "0");
                          OlabUtils.infoLog("item.olab_id = " + item.olab_id);
                          // Set additional fields and append unique key for search to work later
                          item.setUniqueKey();

                          item.parent_id = parentID;
                          item.project_id = this.extractIdFromIdAndName(
                            item.project_id
                          );
                          item.plasmid_id = this.extractIdFromIdAndName(
                            item.plasmid_id
                          );
                          // Add new strain
                          microbesDB
                            .doc(microbeID)
                            .collection("olab_items")
                            .withConverter(OlabStrain.getCreateItemConverter())
                            .doc(item.olab_id)
                            .set(item)
                            .then(
                              function() {
                                // console.log("Document successfully written!");
                                // copy item to a new object and add that to the computed list
                                items.push(Object.assign(new OlabItem(), item));
                              }.bind(this)
                            )
                            .catch(
                              function(error) {
                                // console.error("Error writing document: " + error);
                                this.error = error;
                              }.bind(this)
                            );
                        });
                    }.bind(this)
                  )
                  .catch(
                    function(error) {
                      // console.error("Error writing document: " + error);
                      this.error = error;
                    }.bind(this)
                  );
              }.bind(this)
            )
            .catch(
              function(error) {
                // console.error("Error writing document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
        case "library_sequence":
          var librariesDB = db.collection("libraries");
          OlabUtils.infoLog("item.library_id = " + item.library_id);
          var libraryID = item.library_id.substr(
            0,
            item.library_id.indexOf(" ")
          );
          OlabUtils.infoLog("libraryID = " + libraryID);
          var libraryCount = 0;
          var docID = 0;

          // Validate item's library id
          librariesDB
            .where("olab_id", "==", libraryID)
            .get()
            .then(
              function(querySnapshot) {
                querySnapshot.forEach(
                  function(doc) {
                    OlabUtils.infoLog(doc.id + " => " + doc.data().olab_id);
                    docID = doc.id;
                    libraryCount++;
                  }.bind(this)
                );
                OlabUtils.infoLog(
                  "querySnapshot found count = " + libraryCount
                );

                // Increment libraryID's seq count atomically
                librariesDB
                  .doc(docID)
                  .update({
                    count: firebase.firestore.FieldValue.increment(1)
                  })
                  .then(
                    function() {
                      // Read count value back
                      librariesDB
                        .doc(docID)
                        .get()
                        .then(snapshot => {
                          const tmp_count = snapshot.data().count;
                          OlabUtils.infoLog(
                            "sequence: tmp_count = " + tmp_count
                          );
                          const tmp_countHex = tmp_count
                            .toString(16)
                            .toUpperCase();
                          OlabUtils.infoLog(
                            "sequence: tmp_countHex = " + tmp_countHex
                          );

                          item.olab_id =
                            libraryID +
                            "-" +
                            tmp_countHex.toString().padStart(5, "0");
                          // console.info("id = " + item.olab_id);
                          // Set additional fields and append unique key for search to work later
                          item.setUniqueKey();

                          item.library_id = libraryID;
                          // Add new library sequence
                          librariesDB
                            .doc(docID)
                            .collection("olab_items")
                            .withConverter(
                              OlabSequence.getCreateItemConverter()
                            )
                            .doc(item.olab_id)
                            .set(item)
                            .then(
                              function() {
                                // console.log("Document successfully written!");
                                // copy item to a new object and add that to the computed list
                                items.push(Object.assign(new OlabItem(), item));
                              }.bind(this)
                            )
                            .catch(
                              function(error) {
                                // console.error("Error writing document: " + error);
                                this.error = error;
                              }.bind(this)
                            );
                        });
                    }.bind(this)
                  )
                  .catch(
                    function(error) {
                      // console.error("Error writing document: " + error);
                      this.error = error;
                    }.bind(this)
                  );
              }.bind(this)
            )
            .catch(
              function(error) {
                // console.error("Error writing document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
      }
    },
    saveItem: function({ item, items }) {
      OlabUtils.infoLog(
        "saveItem: item.olab_id = " +
          item.olab_id +
          ", item.olab_type = " +
          item.olab_type +
          ", items = " +
          items
      );

      // Set additional fields and append unique key for search to work later
      item.setUniqueKey();

      // Set library_id if this item is a package item
      if (item.package_type) {
        item.library_id = OlabPackage.pkgTypeToLibraryID(item.package_type);
      }

      switch (item.olab_type) {
        case "project":
          db.collection("projects/PJ/olab_items")
            .withConverter(OlabProject.getUpdateItemConverter())
            .doc(item.olab_id)
            .set(item, { merge: true })
            .then(
              function() {
                OlabUtils.infoLog("Document successfully written!");
                this.updateItems(item, items);
              }.bind(this)
            )
            .catch(
              function(error) {
                OlabUtils.infoLog("Error writing document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
        case "cart":
          var cartsRef =
            "projects/PJ/olab_items/" + item.project_id + "/olab_carts";
          OlabUtils.infoLog("Update Cart: project's carts ref = " + cartsRef);
          db.collection(cartsRef)
            .withConverter(OlabCart.getUpdateCartConverter())
            .doc(item.olab_id)
            .set(item, { merge: true })
            .then(
              function() {
                OlabUtils.infoLog("Document successfully written!");
                this.updateItems(item, items);
              }.bind(this)
            )
            .catch(
              function(error) {
                OlabUtils.infoLog("Error writing document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
        case "package":
          var pkgsRef = "packages/PG/olab_items";
          OlabUtils.infoLog("Update Package: packages ref = " + pkgsRef);
          db.collection(pkgsRef)
            .withConverter(OlabPackage.getUpdatePackageConverter())
            .doc(item.olab_id)
            .set(item, { merge: true })
            .then(
              function() {
                OlabUtils.infoLog("Document successfully written!");
                this.updateItems(item, items);
              }.bind(this)
            )
            .catch(
              function(error) {
                OlabUtils.infoLog("Error writing document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
        case "strain":
          // console.log("update strains = " + item.olab_id);
          var microbeID = item.olab_id.substr(0, item.olab_id.indexOf("-"));
          // console.log("update strains = " + microbeID);
          db.collection("microbes")
            .doc(microbeID)
            .collection("olab_items")
            .withConverter(OlabStrain.getUpdateItemConverter())
            .doc(item.olab_id)
            .set(item, { merge: true })
            .then(
              function() {
                OlabUtils.infoLog("Document successfully written!");
                this.updateItems(item, items);
              }.bind(this)
            )
            .catch(
              function(error) {
                OlabUtils.infoLog("Error writing document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
        case "library_sequence":
          db.collection("libraries")
            .doc(item.library_id)
            .collection("olab_items")
            .withConverter(OlabSequence.getUpdateItemConverter())
            .doc(item.olab_id)
            .set(item, { merge: true })
            .then(
              function() {
                OlabUtils.infoLog("Document successfully written!");
                this.updateItems(item, items);
              }.bind(this)
            )
            .catch(
              function(error) {
                OlabUtils.infoLog("Error writing document: " + error);
                this.error = error;
              }.bind(this)
            );
          break;
      }
    },
    updateUserOnChange: function() {
      db.collection("users/cjcj/olab_users")
        .withConverter(OlabUser.getUpdateOlabUserConverter())
        .doc(this.user.email)
        .set(this.user, { merge: true })
        .then(
          function() {
            OlabUtils.infoLog("Document successfully written!");
          }.bind(this)
        )
        .catch(
          function(error) {
            OlabUtils.infoLog("Error writing document: " + error);
            this.error = error;
          }.bind(this)
        );
    },
    selectCart: function(cart) {
      OlabUtils.infoLog("selectCart cart = " + cart);
      if (
        cart &&
        this.selectedCart &&
        cart.olab_id === this.selectedCart.olab_id
      ) {
        this.selectedCart = null;
        this.selectedProject = null;
        this.user.selected.cart_id = null;
        this.user.selected.project_id = null;

        this.updateUserOnChange();
      } else {
        this.selectedCart = cart;
        this.user.selected.cart_id = cart.olab_id;
        db.collection("projects/PJ/olab_items")
          .doc(cart.project_id)
          .withConverter(OlabItem.getOlabItemConverter())
          .get()
          .then(
            function(doc) {
              if (doc.exists) {
                // Convert to Project object
                this.selectedProject = doc.data();
                this.user.selected.project_id = this.selectedProject.olab_id;
                this.updateUserOnChange();
              } else {
                OlabUtils.infoLog("doSelectCart: No such document!");
              }
            }.bind(this)
          )
          .catch(function(error) {
            OlabUtils.infoLog("doSelectCart: Error getting document:" + error);
          });
      }
    },
    selectPackage: function(pkg) {
      OlabUtils.infoLog("selectPackage pkg = " + pkg);
      if (
        pkg &&
        this.selectedPackage &&
        pkg.olab_id === this.selectedPackage.olab_id
      ) {
        this.selectedPackage = null;
        this.user.selected.package_id = null;
      } else {
        this.selectedPackage = pkg;
        this.user.selected.package_id = pkg.olab_id;
      }
      this.updateUserOnChange();
    },
    updateItems: function(item, items) {
      // Update item in array
      for (let i in items) {
        OlabUtils.infoLog(
          "items[" +
            i +
            "].olab_id = " +
            items[i].olab_id +
            ", item.olab_id = " +
            item.olab_id
        );
        if (items[i].olab_id === item.olab_id) {
          OlabUtils.infoLog(
            "Found items[" + i + "].olab_id = " + items[i].olab_id
          );
          OlabUtils.infoLog("TODO: items[i] might not be of olabItem class");
          items[i].set(item);
          break;
        }
      }
    },
    setInfoMessage: function(infoMsg) {
      this.infoMessage = infoMsg;
    },
    setSaveStatus: function(status) {
      this.saveStatus = status;
    },
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.user = null;
          this.$router.push("login");
        });
    },
    extractIdFromIdAndName: function(idName) {
      if (idName) {
        return idName.substr(0, idName.indexOf(" "));
      }
      return null;
    }
  },
  watch: {
    rejectMessage: function() {
      if (this.rejectMessage) {
        setTimeout(() => {
          this.rejectMessage = null;
        }, 5000);
      }
    },
    infoMessage: function() {
      if (this.infoMessage) {
        setTimeout(() => {
          this.infoMessage = null;
        }, 5000);
      }
    }
  }
};
</script>

<style lang="scss">
$primary: rgb(15, 148, 231);
@import "node_modules/bootstrap/scss/bootstrap";

@import url("https://fonts.googleapis.com/css?family=Merriweather:300,300i|Source+Sans+Pro:200,200i,400,400i,600,600i");

@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,300,700,800|Roboto+Slab:400,100,300,700|Gugi");

:root {
  /* Override Variables */
  --font-family-sans-serif: "Source Sans Pro", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
  --gray-dark: #404040;

  /* Page Variables */
  --font-family-serif: Merriweather, serif;
  --color-text: var(--gray-dark);
  --font-family-text: var(--font-family-serif);
  --font-family-gugi: Gugi, serif;
}

.family-sans {
  font-family: var(--font-family-sans-serif);
}

.family-gugi {
  font-family: var(--font-family-gugi);
}

.brand-color {
  background-color: #e70;
}

body {
  font-family: var(--font-family-text);
  color: var(--color-text);
  font-weight: 200;
}
</style>
